

































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ITransaction, IDelegate, IStakeWrapper } from "@/interfaces";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("network", ["activeDelegates"]),
    ...mapGetters("ui", ["smartbridgeFilter"]),
  },
})
export default class StakeTransactionsMobile extends Vue {
  @Prop({ required: true }) public stakes: IStakeWrapper | null;

  get stakeValues() {
    if (this.stakes) {
      return Object.values(this.stakes);
    }
  }

  private determineStakeTime(seconds: number) {
    return {
      "31557600": "a year",
      "15778800": "6 months",
      "7889400": "3 months",
      "86400": "a day",
    }[seconds];
  }
}
